export { default as murmurHash } from './libs/murmurHash';

export function cx(...args: (string | boolean | undefined)[]) {
  return args.filter(Boolean).join(' ');
}

export function createToggle(init?: boolean) {
  return createSignal(init ?? false);
}

/** 浅层对比两个对象是否相等 */
export function shallow<T extends object>(a: T, b: T) {
  // 获取两个对象的键
  const keys1 = Object.keys(a);
  const keys2 = Object.keys(b);

  // 如果键的数量不相同，则对象不相等
  if (keys1.length !== keys2.length) {
    return false;
  }
  // 检查每个键和值是否相同
  return keys1.every((key) => Object.prototype.hasOwnProperty.call(b, key) && (a as any)[key] === (b as any)[key]);
}

/** 比较两个数组的项是否全等 */
export function arraysEqual<T>(a: T[], b: T[]) {
  if (a.length !== b.length) return false;
  return a.every((val, index) => val === b[index]);
}

// 当前渲染环境是否是爬虫bot
export const isBot = import.meta.env.SSR || navigator.webdriver;

/** 尝试获取根滚动元素 */
export const rootScrollElement: HTMLElement = import.meta.env.SSR
  ? (null as any)
  : document.scrollingElement || document.documentElement || document.body;

/** 滑动手势检测区域 */
export const swipeArea = import.meta.env.SSR ? 0 : Math.ceil(innerWidth * 0.07);

/** 是否支持touch事件 */
export const isSupportTouch = import.meta.env.SSR
  ? false
  : Object.prototype.hasOwnProperty.call(window, 'ontouchstart');

export const easeBack = [0.36, 0.66, 0.04, 1] as const;

export function false2undefined(value?: boolean) {
  return value || undefined;
}
